import { useEffect, useState } from 'react';

export const MOBILE_LAYOUT_BREAKPOINT = '(max-width: 768px)';

export const useIsMobileLayout = (breakpoint: string = MOBILE_LAYOUT_BREAKPOINT): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia(breakpoint);
    const handleChange = () => setIsMobile(mediaQuery.matches);
    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [breakpoint]);

  return isMobile;
};
